import AjaxUtil from '../../axios/axios';

export const send_otp = async(mobileNumber) => {
    try {
        let request = {usernumber: "dumy", toemail: "dummy", tosms: mobileNumber}
        return await AjaxUtil.sendRequest('otpgeneration', request, false, { method: 'post', showError: true} );
    } catch (error) {
        throw error;
    }
}

export const update_password = async(mobileNumber, password, otp) => {
    try {
        let request = {password: AjaxUtil.encryptData(password), otp: otp}
        return await AjaxUtil.sendRequest('updatepassword/'+mobileNumber, request, false, { method: 'put', showError: true} );
    } catch (error) {
        throw error;
    }
}

export const validate_tfa_otp = async (username, email, otp) => {
    try {
        let request = { username, email, otp };
        return await AjaxUtil.sendRequest('api/v1/user/TFA/Validate', request, false, { isAuth: true, method: 'post', showError: true });
    } catch (error) {
        throw error;
    }
}

export const initiate_tfa = async (usernumber, useremail, phonenumber) => {
    try {
        let request = { usernumber, useremail, phonenumber };
        return await AjaxUtil.sendRequest('api/v1/user/TFA/initiate', request, false, { isAuth: true, method: 'post', showError: true });
    } catch (error) {
        throw error;
    }
}